import { MapPin, Utensils, ShoppingBag, Plane, Navigation } from 'lucide-react';

const nearbyPlaces = [
  {
    icon: Utensils,
    name: 'Local Restaurants',
    distance: 'Walking Distance',
    type: 'Dining',
  },
  {
    icon: Plane,
    name: 'Vizag Airport',
    distance: '5 km',
    type: 'Airport',
  },
  {
    icon: Navigation,
    name: 'Old Gajuwaka',
    distance: 'Prime Location',
    type: 'Area',
  },
  {
    icon: ShoppingBag,
    name: 'Local Markets',
    distance: 'Walking Distance',
    type: 'Shopping',
  },
];

export function Location() {
  return (
    <section id="location" className="py-16 sm:py-24 bg-white">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="mb-4">Prime Location</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Strategically located in Gajuwaka, Visakhapatnam with easy access to major landmarks and amenities.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          {/* Map */}
          <div className="rounded-xl overflow-hidden shadow-lg h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3799.4!2d83.204!3d17.735!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTfCsDQ0JzA2LjAiTiA4M8KwMTInMTQuNCJF!5e0!3m2!1sen!2sin!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Hotel A.S.K Grand Location"
            ></iframe>
          </div>

          {/* Address & Nearby Places */}
          <div>
            <div className="bg-gold-50 rounded-xl p-6 mb-6">
              <div className="flex items-start gap-3 mb-4">
                <MapPin className="w-6 h-6 text-gold-600 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="mb-2">Address</h3>
                  <p className="text-gray-700">
                    10-2-9/1, Mehar Nagar<br />
                    Old Gajuwaka<br />
                    Visakhapatnam, Andhra Pradesh 530026
                  </p>
                </div>
              </div>
              <a
                href="https://goo.gl/maps/your-actual-google-maps-link"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-gold-600 hover:text-gold-700"
              >
                <Navigation className="w-4 h-4" />
                <span>Get Directions</span>
              </a>
            </div>

            <h3 className="mb-4">Nearby Attractions</h3>
            <div className="space-y-4">
              {nearbyPlaces.map((place, index) => {
                const Icon = place.icon;
                return (
                  <div
                    key={index}
                    className="flex items-center gap-4 bg-white border border-gray-200 rounded-lg p-4"
                  >
                    <div className="w-10 h-10 bg-gold-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <Icon className="w-5 h-5 text-gold-600" />
                    </div>
                    <div className="flex-1">
                      <p className="text-gray-900">{place.name}</p>
                      <p className="text-gray-500 text-sm">{place.type}</p>
                    </div>
                    <span className="text-gold-600 text-sm">{place.distance}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>


      </div>
    </section>
  );
}
